// extracted by mini-css-extract-plugin
export var container = "_dt-0";
export var content = "_dt-3";
export var customerTitle = "_dt-4";
export var empty = "_dt-5";
export var gray = "_dt-6";
export var header = "_dt-7";
export var info = "_dt-8";
export var loading = "_dt-2";
export var loadingCard = "_dt-9";
export var oneLine = "_dt-a";
export var personName = "_dt-e";
export var pillContainer = "_dt-b";
export var selected = "_dt-1";
export var text = "_dt-c";
export var twoLines = "_dt-d";
export var unread = "_dt-f";
export var unreadIndicator = "_dt-g";